import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalReceiptDetailsComponent } from './modal-receipt-details.component';
import {ModalModule} from "ngx-bootstrap/modal";
import {BtnCloseModule} from "../../btn-close/btn-close.module";
import {SharedModule} from "../../../../modules/shared.module";
import {PreloaderModule} from "../../preloader/preloader.module";



@NgModule({
  declarations: [
    ModalReceiptDetailsComponent
  ],
  exports: [
    ModalReceiptDetailsComponent
  ],
  imports: [
    CommonModule,
    ModalModule,
    BtnCloseModule,
    SharedModule,
    PreloaderModule
  ]
})
export class ModalReceiptDetailsModule { }
